import { birthdayBalloons, weddingGuestBook, inkyGuestBook, birthdayCake, weddingCreamAndGold, weddingGardenRose, weddingGardenScript, weddingNatural, weddingSpringGreenery, generalSolid, popHearts, vintageSymmetry, diamondCongrats, paintDaubs, birthdayCandles, doodleCoffee, starPop, meadowFlowers, mountainView, bigCongrats, windflower, schoolSpirit, christmasPresents, holidaySnow, } from "./themes/index.js";
export const compilationThemes = [
    birthdayBalloons,
    weddingGuestBook,
    inkyGuestBook,
    birthdayCake,
    weddingCreamAndGold,
    weddingGardenRose,
    weddingGardenScript,
    weddingNatural,
    weddingSpringGreenery,
    generalSolid,
    popHearts,
    diamondCongrats,
    vintageSymmetry,
    paintDaubs,
    birthdayCandles,
    doodleCoffee,
    starPop,
    meadowFlowers,
    mountainView,
    bigCongrats,
    windflower,
    schoolSpirit,
    christmasPresents,
    holidaySnow,
];
